// klaviyo back in stock
    klaviyo.init({
      account: "VATFVX",
      platform: "shopify"
    });
    klaviyo.enable("backinstock",{ 
    trigger: {
      product_page_text: "Schreib mir, wenn es wieder auf Lager ist",
      product_page_class: "button button--xl button--subdued",
      alternate_anchor: "buy-buttons",
      replace_anchor: true
    },
    modal: {
     font_family: "inherit",
     body_content: "Registriere Dich hier, damit Du Bescheid bekommst, sobald Dein Lieblingsprodukt wieder verfügbar ist.",
     email_field_label: "Deine E-Mail",
     button_label: "informiere mich, wenn wieder verfügbar",
     subscription_success_label: "Du bist dabei! Wir melden uns, sobald es wieder auf Lager ist. :)",
     footer_content: '',
     drop_background_color: "#000",
     background_color: "#fff",
     text_color: "#222",
     button_text_color: "#fff",
     button_background_color: "#000",
     close_button_color: "#ccc",
     error_background_color: "#fcd6d7",
     error_text_color: "#C72E2F",
     success_background_color: "#d3efcd",
     success_text_color: "#1B9500"
    }
  });